<template>
  <div>
    <b-container>
      <b-row align-h="start">
        <b-col class="font-toolbar-left-col"></b-col>
        <b-col class="font-toolbar-right-col">
          <b-dropdown
            class="font-dropdown"
            :text="nameFont"
            :style="{ fontFamily: nameFont}"
            variant="primary"
            v-model="nameFont"
            split
          >
            <b-dropdown-item
              :key="font"
              v-for="font in fonts"
              value="font"
              @click="selectFont(font)"
              :style="{ fontFamily: font}"
            >{{font}}</b-dropdown-item>
          </b-dropdown>

          <b-dropdown
            class="font-size-dropdown"
            :text="fontSize"
            variant="primary"
            v-model="fontSize"
          >
            <b-dropdown-item
              :key="size"
              v-for="size in fontSizes"
              value="size"
              @click="selectFontSize(size)"
            >{{size}}</b-dropdown-item>
          </b-dropdown>

          <b-button-group class="font-alignment-button-group">
            <b-button variant="primary" @click="selectTextAlign('left')">
              <img alt="Align Left" src="../assets/align-left-24.png" />
            </b-button>
            <b-button variant="primary" @click="selectTextAlign('center')">
              <img alt="Align Center" src="../assets/align-center-24.png" />
            </b-button>
            <b-button variant="primary" @click="selectTextAlign('right')">
              <img alt="Align Right" src="../assets/align-right-24.png" />
            </b-button>
          </b-button-group>

          <b-dropdown class="font-color-dropdown" variant="primary">
            <template v-slot:button-content>
              <span class="font-color-dot-span" :style="{ backgroundColor: fontRGBAColor }"></span>
            </template>
            <b-dropdown-form>
              <div>
                <color-picker
                  class="fancy-editor-color-picker"
                  theme="light"
                  :sucker-hide="true"
                  @changeColor="selectFontColor"
                />
                <!-- :sucker-canvas="suckerCanvas"
                :sucker-area="suckerArea"
                @openSucker="openSucker"-->
              </div>
            </b-dropdown-form>
          </b-dropdown>

          <b-button class="delete-button" variant="primary" @click="deleteObject()">
            <img class="trashcan-icon" alt="Delete" src="../assets/empty-trash-50.png" />
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-row :style="{ height: viewportHeight + 'px' }" class="justify-content-md-center">
        <b-col class="main-editor-left-col" align-self="center">
          <b-row align-h="center" align-v="center" style="margin-bottom: 10px">
            <b-form-checkbox
              id="watermark-checkbox-1"
              name="checkbox-1"
              value="true"
              unchecked-value="false"
              @input="toggleWatermark"
              checked="false"
            >Show watermark</b-form-checkbox>
          </b-row>

          <b-row align-h="center" align-v="center">
            <b-button
              class="add-textbox-button"
              variant="primary"
              @click="addTextboxElement()"
            >Add New Textbox</b-button>
          </b-row>
          <b-row align-h="center" align-v="center">
            <b-button
              class="add-image-button"
              variant="primary"
              v-b-modal.add-image-modal
            >Add New Image</b-button>
            <b-modal
              id="add-image-modal"
              centered
              size="lg"
              title="Add a new image to this page!"
              hide-footer
            >
              <AddImage @uploadSuccess="postDesignPageImage" @cancelClick="toggleImageModal"></AddImage>
            </b-modal>
          </b-row>
          <b-row align-h="center" align-v="center">
            <a
              id="download"
              :download="downloadPNGFileName"
              :href="hrefPNG"
              class="btn btn-primary downloadButton"
              @click="downloadCanvas()"
            >Download as PNG</a>
          </b-row>
          <b-row align-h="center" align-v="center">
            <ImageSelector :images="images"></ImageSelector>
          </b-row>
        </b-col>
        <b-col class="main-editor-right-col">
          <div
            id="viewport"
            class="canvaseditor"
            :style="{ height: viewportHeight + 'px', width: viewportWidth + 'px' }"
          >
            <canvas contenteditable="true" id="mainCanvas" ref="can"></canvas>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { fabric } from "fabric";

import FontFaceObserver from "fontfaceobserver";
import colorPicker from "@caohenghu/vue-colorpicker";
import AddImage from "./AddImage.vue";
import ImageSelector from "./ImageSelector";

export default {
  name: "CanvasEditor",
  props: {
    msg: String,
    page: null,
    designID: null,
    canvasJSON: null,
    images: Array,
  },
  components: {
    AddImage,
    colorPicker,
    ImageSelector,
  },
  data() {
    return {
      canvasWidth: 480,
      canvasHeight: 672,
      canvas: null,
      fonts: ["Roboto", "Modak", "Lato", "Yellowtail", "Merienda One"],
      fontSizes: [
        "6",
        "8",
        "10",
        "12",
        "14",
        "16",
        "18",
        "21",
        "24",
        "28",
        "32",
        "36",
        "42",
        "48",
        "56",
        "64",
        "72",
        "80",
        "88",
        "96",
        "104",
        "120",
        "144",
      ],
      defaultName: "Fancy Editor",
      hrefPNG: "",
      downloadPNGFileName: "myImage.png",
      nameFont: "Roboto",
      fontSize: "56",
      textAlign: "center",
      fontRGBColor: "rgb(0,0,0)",
      fontRGBAColor: "rgba(0,0,0,1)",
      fontOpacity: 1,
      textboxes: [],
      selectedTextbox: null,
      selectedTextboxIndex: -1,
      watermark: null,

      viewportHeight: 500,
      viewportWidth: 700,

      isDragging: false,
      selection: true,
      lastPosX: 0,
      lastPosY: 0,

      imageJSONMap: null,
      imageObjectMap: null,
      elements: [],
      canvasObjectsIDMap: null,
    };
  },
  methods: {
    toggleImageModal() {
      this.$root.$emit("bv::toggle::modal", "add-image-modal");
    },
    deleteObject() {
      this.canvas.getActiveObjects().forEach((obj) => {
        this.canvas.remove(obj);
      });
      this.canvas.discardActiveObject().renderAll();

      this.postChange();
    },
    toggleWatermark(event) {
      if (event === "true") {
        this.watermark.set("opacity", 0.1);
      } else {
        this.watermark.set("opacity", 0);
      }

      this.canvas.requestRenderAll();
    },
    selectFont(font) {
      this.nameFont = font;
      var myfont = new FontFaceObserver(font);
      myfont
        .load()
        .then(
          function () {
            this.textboxes[this.selectedTextboxIndex].set("fontFamily", font);
            this.canvas.requestRenderAll();
            this.postChange();
          }.bind(this)
        )
        .catch(function () {
          //   console.log(e);
          alert("font loading failed " + font);
        });
    },
    selectFontColor(color) {
      //   console.log(color.rgba);
      var rgbaColor = "rgba(".concat(
        color.rgba.r,
        ",",
        color.rgba.g,
        ",",
        color.rgba.b,
        ",",
        color.rgba.a,
        ")"
      );
      var rgbColor = "rgb(".concat(
        color.rgba.r,
        ",",
        color.rgba.g,
        ",",
        color.rgba.b,
        ")"
      );
      //   console.log(rgbColor);
      //   console.log(this.selectedTextboxIndex);
      //   console.log(this.textboxes[this.selectedTextboxIndex]);
      this.fontRGBColor = rgbColor;
      this.fontRGBAColor = rgbaColor;
      this.fontOpacity = color.rgba.a;
      this.textboxes[this.selectedTextboxIndex].set("fill", rgbColor);
      this.textboxes[this.selectedTextboxIndex].set("fillType", rgbaColor);
      this.textboxes[this.selectedTextboxIndex].set("opacity", color.rgba.a);

      this.canvas.requestRenderAll();

      this.postChange();
    },
    selectFontSize(size) {
      // Get name textbox current left boundary to keep it there
      var currLeft = this.textboxes[this.selectedTextboxIndex].left;

      // Set fontSize on data
      this.fontSize = size;

      // Set font on nameTextbox
      // and keep on same left position as before
      // resize width to text boundaries
      this.textboxes[this.selectedTextboxIndex].set("fontSize", size);
      this.textboxes[this.selectedTextboxIndex].set("width", 10);
      this.textboxes[this.selectedTextboxIndex].set("left", currLeft);

      // render
      this.canvas.requestRenderAll();

      this.postChange();
    },
    selectTextAlign(align) {
      // Set textAlign on data
      this.textAlign = align;
      this.textboxes[this.selectedTextboxIndex].set("textAlign", align);

      // render
      this.canvas.requestRenderAll();
    },
    onMouseUp() {
      //   console.log("onMouseUp");
      this.canvas.forEachObject(function (obj) {
        if (obj.id === "verticalCenterLine") obj.set("opacity", 0);
        if (obj.id === "horizontalCenterLine") obj.set("opacity", 0);
      });

      this.isDragging = false;
      this.selection = true;
    },

    onMouseDown(options) {
      //   console.log("onMouseDown");
      var evt = options.e;
      this.isDragging = true;
      this.selection = false;
      this.lastPosX = evt.clientX;
      this.lastPosY = evt.clientY;
    },

    drag(options) {
      console.log("inside drag | this.isDragging ", this.isDragging);
      if (this.isDragging && this.selectedTextboxIndex < 0) {
        var e = options.e;
        var vpt = this.canvas.viewportTransform;
        vpt[4] += e.clientX - this.lastPosX;
        vpt[5] += e.clientY - this.lastPosY;
        this.canvas.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
      }
    },

    zoomOnScroll(opt) {
      var delta = opt.e.deltaY;
      var zoom = this.canvas.getZoom();
      zoom *= 0.999 ** delta;
      if (zoom > 20) zoom = 20;
      if (zoom < 0.01) zoom = 0.01;
      this.canvas.setZoom(zoom);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    },

    clearSelection() {
      console.log("clear selection");
      //   this.selectedTextboxIndex = -1;
    },

    setSelectedTextbox(options) {
      var id = options.target.id;
      if (id !== null && id.startsWith("textBox")) {
        var idLength = id.length;
        var index = id.substring(7, idLength);
        this.selectedTextboxIndex = +index;

        var selectedFontFamily = this.textboxes[this.selectedTextboxIndex]
          .fontFamily;
        var selectedFontSize = this.textboxes[this.selectedTextboxIndex]
          .fontSize;
        var selectedTextAlign = this.textboxes[this.selectedTextboxIndex]
          .textAlign;
        var selectedTextRGBA = this.textboxes[this.selectedTextboxIndex]
          .fillType;
        var selectedTextRGB = this.textboxes[this.selectedTextboxIndex].fill;
        var selectedTextOpacity = this.textboxes[this.selectedTextboxIndex]
          .opacity;

        this.nameFont = selectedFontFamily;
        this.fontSize = selectedFontSize;
        this.textAlign = selectedTextAlign;
        this.fontRGBAColor = selectedTextRGBA;
        this.fontRGBColor = selectedTextRGB;
        this.fontOpacity = selectedTextOpacity;
      }
    },

    // addTextboxElement adds a textbox object to the canvas
    // textboxJSON param is optional
    // if passed, then it will take all properties from the JSON
    // passed
    // If not passed, it builds a default textbox
    addTextboxElement(textboxJSON) {
      var numTextBoxes = this.textboxes.length;
      var id = "textBox" + numTextBoxes;

      var textbox = null;

      if (!textboxJSON) {
        textbox = new fabric.Textbox(this.defaultName, {
          left: 50,
          top: 50,
          width: 150,
          fontSize: this.fontSize,
          fontFamily: this.nameFont,
          name: "NameTextboxProperty",
          id: id,
          textAlign: "center",
          fill: this.fontRGBColor,
          fillType: this.fontRGBAColor,
          opacity: this.fontOpacity,
        });
      } else {
        console.log("json textbox", textboxJSON);
        textboxJSON.id = id;
        textbox = new fabric.Textbox(textboxJSON.text, textboxJSON);
      }

      textbox.setControlVisible("tl", false);
      textbox.setControlVisible("tr", false);
      textbox.setControlVisible("bl", false);
      textbox.setControlVisible("br", false);
      textbox.setControlVisible("mt", false);
      textbox.setControlVisible("mb", false);

      this.textboxes.push(textbox);
      this.selectedTextboxIndex = numTextBoxes;

      this.canvas.add(textbox).setActiveObject(textbox);
      //   this.canvas.bringToFront(textbox);

      this.canvasObjectsIDMap.set(id, textbox);

      if (!textboxJSON) {
        this.postChange();
      }

      return textbox;
    },

    addWatermarkElement() {
      var id = "watermark";

      var watermarkString = this.defaultName;
      var i;
      for (i = 0; i < 100; i++) {
        watermarkString += " " + this.defaultName;
      }

      var watermark = new fabric.Textbox(watermarkString, {
        left: 0,
        top: 0,
        width: this.canvasWidth,
        fontSize: this.canvasHeight / 4,
        fontFamily: this.nameFont,
        id: id,
        textAlign: "left",
        opacity: 0,
      });

      watermark.hasControls = watermark.hasBorders = watermark.selectable = false;

      this.watermark = watermark;
      this.canvas.add(watermark);
      this.canvas.bringToFront(watermark);
    },

    postDesignPageImage(image) {
      this.$root.$emit("bv::hide::modal", "add-image-modal");
      axios
        .post(
          process.env.VUE_APP_API_SERVER.concat(
            "/v1/designs/",
            this.designID,
            "/pages/",
            this.page.design_page_id,
            "/elements"
          ),
          {
            image_id: image.image_id,
          }
        )
        .then((response) => {
          console.log(response.data);
          this.addImage(image);
        })
        .catch((error) => alert(error))
        .finally(() => (this.loading = false));
    },

    addImage(image) {
      console.log("addImage", image);
      var imageJSON = null;
      var id = image.design_page_element_id;
      var top = 0;
      var left = 0;
      var jsonExists = this.imageJSONMap.has(id);
      if (jsonExists) {
        console.log("json exists");
        imageJSON = this.imageJSONMap.get(id);
        top = imageJSON.top;
        left = imageJSON.left;
      }

      const promiseArray = [];

      // ADD IMAGE
      const p = new Promise((resolve) => {
        fabric.Image.fromURL(
          image.image_url,
          function (img) {
            // BORDER
            img.scale(1.0).set({
              stroke: "black",
              strokeWidth: 0.05,
            });
            // img.hasControls = false;
            // img.selectable = false;
            img.hasBorders = false;
            img.id = id;
            img.top = top;
            img.left = left;
            this.canvas.add(img);
            this.canvas.requestRenderAll();
            console.log("about to resolve");
            resolve(img);
            console.log("IMAGE ADDED subfunction");
            this.canvasObjectsIDMap.set(id, img);
          }.bind(this),
          {
            crossOrigin: "anonymous",
          }
        );
      });
      console.log("about to push");
      promiseArray.push(p);
      console.log("will now wait for all to finish");

      //   var promisesFulfilled = false;

      Promise.all(promiseArray).then((img) => {
        // promisesFulfilled = true;
        console.log("i promise you i'm done");
        return img;
      });
      //   while (!promisesFulfilled) {
      //     continue;
      //   }
    },

    onChange(options) {
      options.target.setCoords();
      this.canvas.forEachObject(function (obj) {
        if (obj === options.target) return;
        if (obj.id === "baseImg") return;
        if (options.target.id === "verticalCenterLine") return;
        if (options.target.id === "horizontalCenterLine") return;

        // In here, the only things moving is the textbox
        // Therefore:
        // obj = verticalLine
        // options.target = textbox

        var targetWidth = options.target.width * options.target.scaleX;
        var targetHeight = options.target.height * options.target.scaleY;

        var targetMiddleX = options.target.left + targetWidth / 2;
        var targetMiddleY = options.target.top + targetHeight / 2;

        // console.log(
        //   obj.id,
        //   "w",
        //   obj.width,
        //   "h",
        //   obj.height,
        //   "l",
        //   obj.left,
        //   "t",
        //   obj.top,
        //   options.target.id,
        //   "w",
        //   targetWidth,
        //   "h",
        //   targetHeight,
        //   "l",
        //   options.target.left,
        //   "t",
        //   options.target.top,
        //   "m",
        //   targetMiddleX,
        //   "fs",
        //   options.target.fontSize * options.target.scaleY
        // );

        if (obj.id == "verticalCenterLine") {
          if (targetMiddleX + 5 >= obj.left && targetMiddleX - 5 <= obj.left) {
            obj.set("opacity", 1);
            options.target.set("left", obj.left - targetWidth / 2);
          } else {
            obj.set("opacity", 0);
          }
        }

        if (obj.id == "horizontalCenterLine") {
          if (targetMiddleY + 5 >= obj.top && targetMiddleY - 5 <= obj.top) {
            obj.set("opacity", 1);
            options.target.set("top", obj.top - targetHeight / 2);
          } else {
            obj.set("opacity", 0);
          }
        }
      });
    },

    initiateCanva() {
      // CREATE CANVAS
      const ref = this.$refs.can;
      const canvas = new fabric.Canvas(ref);

      this.canvas = canvas;
      this.canvas.preserveObjectStacking = true;
      // SET THE NAME OF THE DOWNLOAD FILE
      this.downloadPNGFileName = this.page.page_name.concat(".png");
    },

    // postRenderCanvas renders the canvas
    // when component is rendered
    postRenderCanvas() {
      this.canvas.setHeight(this.canvasHeight);
      this.canvas.setWidth(this.canvasWidth);

      // ZOOM
      var zoomRatioWidth = this.viewportWidth / this.canvasWidth;
      var zoomRatioHeight = this.viewportHeight / this.canvasHeight;

      var zoom = Math.min(zoomRatioWidth, zoomRatioHeight);
      if (zoom < 1.0) {
        this.canvas.setZoom(zoom);
      }

      // ADD VERTICAL CENTER LINE
      var verticalCenterLine = new fabric.Line(
        [this.canvasWidth / 2, 0, this.canvasWidth / 2, this.canvasHeight],
        {
          fill: "black",
          stroke: "black",
          strokeWidth: 1,
          selectable: false,
          evented: false,
          id: "verticalCenterLine",
          opacity: 0,
        }
      );
      this.canvas.add(verticalCenterLine);

      // ADD HORIZONTAL CENTER LINE
      var horizontalCenterLine = new fabric.Line(
        [0, this.canvasHeight / 2, this.canvasWidth, this.canvasHeight / 2],
        {
          fill: "black",
          stroke: "black",
          strokeWidth: 1,
          selectable: false,
          evented: false,
          id: "horizontalCenterLine",
          opacity: 0,
        }
      );
      this.canvas.add(horizontalCenterLine);

      this.canvas.renderAll();

      this.canvas.on({
        "object:modified": this.postChange,
        "object:moving": this.onChange,
        "object:scaling": this.onChange,
        "object:rotating": this.onChange,
        "selection:updated": this.setSelectedTextbox,
        "selection:created": this.setSelectedTextbox,
        "selection:cleared": this.clearSelection,
        "mouse:up": this.onMouseUp,
        "mouse:wheel": this.zoomOnScroll,
        "mouse:down": this.onMouseDown,
        // "mouse:move": this.drag,
      });

      // EVENT LISTENER EXAMPLE
      //   ref.addEventListener(
      //     "mouseup",
      //     () => {
      //       console.log(":)");
      //     },
      //     false
      //   );

      //   ref.addEventListener(
      //     "keydown",
      //     (event) => {
      //       console.log("keydown", event.target);
      //     },
      //     false
      //   );
    },

    // download the canvas
    downloadCanvas() {
      var zoom = this.canvas.getZoom();
      this.canvas.setZoom(1.0);

      var dataURL = this.canvas.toDataURL("png");
      this.hrefPNG = dataURL;
      this.canvas.setZoom(zoom);
    },

    // communicate a change was made up the design tree
    postChange() {
      var canvasJSON = this.canvas.toJSON(["id", "_controlsVisibility"]);
      console.log(canvasJSON);
      this.$emit("modified", this.page.design_page_id, canvasJSON);
    },
  },

  mounted() {
    this.imageJSONMap = new Map();
    this.canvasObjectsIDMap = new Map();

    var imageObjectMap = new Map();

    // initiate canvas first
    this.initiateCanva();

    var maxHeight = 500;
    var maxWidth = 500;

    // loop through images passed in from parent.
    // If there is NOT a canvasJSON, go ahead and add images.
    // If there is one, they will be added in the loop below
    // to preserve the layers
    for (i = 0; i < this.page.images.length; i++) {
      var image = this.page.images[i];
      if (image.height_px > maxHeight) {
        maxHeight = image.height_px;
      }
      if (image.width_px > maxWidth) {
        maxWidth = image.width_px;
      }

      imageObjectMap.set(image.design_page_element_id, image);

      if (!this.canvasJSON) {
        this.addImage(image);
      }
      console.log("image added");
    }

    // if canvasJSON prop was passed into component
    // loop through it to add objects
    if (this.canvasJSON) {
      console.log("rendering from json", this.canvasJSON);

      // loop through objects
      // add the textboxes
      // build image map from stored JSON
      var i;
      for (i = 0; i < this.canvasJSON.objects.length; i++) {
        var objectJSON = this.canvasJSON.objects[i];

        // textboxes
        if (objectJSON.type === "textbox") {
          this.nameFont = objectJSON.fontFamily;
          var textbox = this.addTextboxElement(objectJSON);
          console.log(textbox);
          console.log("TEXTBOX ADDED");
        }

        // images
        // build imageJSONMap
        if (objectJSON.type === "image") {
          this.imageJSONMap.set(objectJSON.id, objectJSON);

          image = imageObjectMap.get(objectJSON.id);
          this.canvasJSON.objects[i].src = image.image_url;
          var img = this.addImage(image);
          console.log(img);
          console.log("IMAGE ADDED");
        }
      }

      //   this.canvas.loadFromJSON(
      //     this.canvasJSON,
      //     this.canvas.renderAll.bind(this.canvas)
      //   );
    }

    this.canvasHeight = maxHeight;
    this.canvasWidth = maxWidth;

    this.postRenderCanvas();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Modak&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Yellowtail&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@100;300&family=Modak&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Merienda+One&display=swap");

body #montserrat {
  font-family: "Montserrat", sans-serif;
}

body #leftCol {
  text-align: left;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.baseImage {
  position: absolute;
  top: 0;
  left: 0;
}

.downloadButton {
  position: relative;
  margin: 20px 0;
}

.add-image-button {
  position: relative;
  margin: 20px 0;
}

.font-dropdown {
  width: 140px;
}

.font-dropdown /deep/ .dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.font-size-dropdown {
  margin-left: 10px;
}

.font-alignment-button-group {
  margin-left: 10px;
  height: 33.5px;
}

.font-size-dropdown /deep/ .dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.font-toolbar-left-col {
  max-width: 25%;
}
.font-toolbar-right-col {
  min-width: 75%;
  text-align: left;
}

.main-editor-left-col {
  max-width: 25%;
}
.main-editor-right-col {
  min-width: 75%;
}

.fancy-editor-color-picker {
  width: 220px !important;
  white-space: pre-wrap;
}

.font-color-dropdown {
  margin-left: 10px;
}

.font-color-dot-span {
  height: 20px;
  width: 20px;
  border-radius: 25%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.delete-button {
  height: 33.5px;
  margin-left: 10px;
}

.trashcan-icon {
  display: inline-block;
  height: 20px;
}

#viewport {
  left: 0;
  position: absolute;
  top: 0;
  /* overflow: auto; */
  overflow: hidden;
  border: 1px solid black;
}
</style>
